module.exports = {
      id: "instagram-square-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-9780240c1c89505db7f372dec3b5867e.svg#instagram-square",
      toString: function () {
        return this.url;
      }
    }